/**
* DevExpress Dashboard (_custom-shape-file-data.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { PropertyCategory } from '../../../metadata/_base-metadata';
export let shapeData = { propertyName: 'shapeData', modelName: '@ShapeData', displayName: 'DashboardWebStringId.Map.CustomMapFile', defaultVal: undefined, category: PropertyCategory.Map };
export let attributeData = { propertyName: 'attributeData', modelName: '@AttributeData', displayName: 'DashboardWebStringId.Map.CustomAttributeFile', defaultVal: undefined, category: PropertyCategory.Map };
export let customShapefileDataSerializationsInfo = [shapeData, attributeData];
